import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { DownloadSimple, Printer, SpinnerGap } from '@phosphor-icons/react';
import { internshipAPI } from '../../services/api';
import LetterDocument from './LetterDocument';

const LetterView = () => {
  const { code } = useParams();
  const [searchParams] = useSearchParams();
  const unsigned = searchParams.get('unsigned') === '1' || searchParams.get('unsigned') === 'true';
  const autoPrint = searchParams.get('print') === '1';
  const [letter, setLetter] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = `${unsigned ? 'Unsigned letter' : 'Letter'} ${code} | Growmore IT Services`;
    internshipAPI.letter(code, unsigned)
      .then(({ data }) => setLetter(data.letter))
      .catch(() => setError('This letter ID was not found.'));
  }, [code, unsigned]);

  useEffect(() => {
    if (!letter || !autoPrint) return undefined;
    const timer = window.setTimeout(() => window.print(), 450);
    return () => window.clearTimeout(timer);
  }, [letter, autoPrint]);

  const printLetter = () => {
    window.print();
  };

  return (
    <div className="letter-verify min-h-screen bg-slate-200 print:bg-white print:min-h-0">
      <div className="letter-toolbar no-print sticky top-0 z-20 bg-white border-b border-gray-100">
        <div className="px-4 py-3 flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">
              {unsigned ? 'Without stamp & sign' : 'Official letter'}
            </p>
            <p className="text-sm font-semibold text-gray-800">ID {code}</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={printLetter} className="btn-primary text-white inline-flex items-center gap-2 text-sm">
              <Printer className="w-4 h-4" /> Print
            </button>
            <button type="button" onClick={printLetter} className="px-4 py-2 rounded-xl bg-white border border-gray-200 text-sm font-semibold inline-flex items-center gap-2">
              <DownloadSimple className="w-4 h-4" /> Download PDF
            </button>
          </div>
        </div>
      </div>
      {error && <p className="text-center text-red-600 py-10">{error}</p>}
      {!letter && !error && (
        <p className="flex justify-center text-gray-500 py-16"><SpinnerGap className="w-6 h-6 animate-spin" /></p>
      )}
      {letter && (
        <div className="letter-print-stage py-6 px-3 flex justify-center print:p-0 print:block">
          <LetterDocument letter={letter} unsigned={unsigned} />
        </div>
      )}
    </div>
  );
};

export default LetterView;
